import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

import { DutchAddress } from '@ap/interface-generic';

import { AddressForm } from './dutch-address.model';

@Injectable()
export class ApDutchAddressService {
    /**
     * The ApDutchAddressService can be used to construct form group to be used with ApDutchAddressComponent
     * @returns = AddressForm
     */
    public createFormGroup(required: boolean, dutchAddress: DutchAddress = new DutchAddress()): FormGroup<AddressForm> {
        return new FormGroup<AddressForm>({
            postalCode: new FormControl<string>(dutchAddress.zipcode, this.require([], required)),
            houseNumber: new FormControl<number>(dutchAddress.housenumber, {
                updateOn: 'blur',
                validators: this.require([Validators.pattern(/^[1-9][\d]{0,5}$/)], required)
            }),
            houseNumberSuffix: new FormControl<string>(dutchAddress.housenumbersuffix, [Validators.maxLength(6)]),
            street: new FormControl<string>(dutchAddress.street, this.require([Validators.maxLength(60)], required)),
            city: new FormControl<string>(dutchAddress.city, this.require([Validators.maxLength(60)], required)),
            retrieved: new FormControl<boolean>(false)
        });
    }

    private require(validators: ValidatorFn[], required: boolean): ValidatorFn[] {
        return required ? [...validators, Validators.required] : validators;
    }
}
